module.exports = __webpack_public_path__ + "img/term_condition.1cc60d70.png";